<template>
  <span
    :class="['like-animation-wrapper', isDesktop ? 'desktop-layout' : '', size]"
    ref="lavContainer"
    v-if="show"
  >
    <lottie-animation
      ref="anim"
      :animationData="JSON.parse(JSON.stringify(jsonData))"
      :loop="false"
      :autoPlay="false"
      :speed="1"
      @loopComplete="loopComplete"
      @complete="complete"
      @enterFrame="enterFrame"
      @segmentStart="segmentStart"
      @stopped="stopped"
    />
  </span>
</template>
<script>
  import LottieAnimation from 'lottie-web-vue'
  import { mapState } from 'vuex'
  /**
   * bugs:
   * https://github.com/airbnb/lottie-web/issues/1733
   * https://github.com/airbnb/lottie-web/issues/2093
   */

  export default {
    components: {
      LottieAnimation,
    },
    data() {
      return {
        show: false,
        jsonData: (() => {
          const data = require('@/assets/animation/like.json')
          data.w = '158'
          data.h = '132'
          return data
        })(),
      }
    },
    props: {
      size: {
        default: 'default',
        type: String,
      },
    },
    computed: {
      ...mapState(['isDesktop']),
    },
    methods: {
      loopComplete() {},
      complete() {
        this.$emit('animationComplete')
        this.stop()
      },
      enterFrame() {},
      segmentStart() {},
      stopped() {},
      play() {
        this.show = true
        this.$nextTick(() => {
          this.$refs.anim.play()
        })
      },
      stop() {
        this.$refs.anim.stop()
        this.$nextTick(() => {
          this.show = false
        })
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
